import PropTypes from 'prop-types';
import React, {Component} from 'react';

import {VM} from '@hetao/scratch-core';
import VirtualKeyBoard from './VirtualKeyBoard.jsx';
import omit from 'lodash.omit';
import bindAll from 'lodash.bindall';
import classnames from 'classnames';
import GblobalmenuBarClassStyle from '../menu-bar/menu-bar.css';
import style from './index.css';
import simulateKeyBoard from '../../utils/simulateKeyBoard.js';
import Portal from './portal.jsx';

const switchClassName = classnames('virtualKeyBoard-switch');

// 需要动态计算header高度，为计算switch 开关的位置，重新获取header高度。
const GblobalmenuBarClassHash = GblobalmenuBarClassStyle['menu-bar'];

// Svg resources
const ArrowTopSvgCom = require('!@svgr/webpack!./assets/top.r.svg').default;
const ArrowDownSvgCom = require('!@svgr/webpack!./assets/down.r.svg').default;
const ArrowRightSvgCom = require('!@svgr/webpack!./assets/right.r.svg').default;
const ArrowLeftSvgCom = require('!@svgr/webpack!./assets/left.r.svg').default;
const SpaceSvgCom = require('!@svgr/webpack!./assets/space.r.svg').default;
const ASvgCom = require('!@svgr/webpack!./assets/a.r.svg').default;
const SSvgCom = require('!@svgr/webpack!./assets/s.r.svg').default;
const WSvgCom = require('!@svgr/webpack!./assets/w.r.svg').default;
const DSvgCom = require('!@svgr/webpack!./assets/d.r.svg').default;
const SwitchSvg = require('!@svgr/webpack!./assets/switch.r.svg').default;

class KeyBoardLogic extends Component {

    constructor (props){
        super(props);
        this.wrapEle = this.getContainer(); // 当前组件渲染到的节点
        this.switchRef = null;
        this.supportedKeys = [];
        this.state = {
            isFirstDragin: true,
            // keyController 是否显示 all virtualController
            controllerVisible: false,
            // 当前选中的 keyId, 也就是 arrowController | keyController 的item的Id
            // 目前暂定单点触控，后期可能支持多点触控，那时格式会变成数组
            currentActiveKeyIds: []
        };
        bindAll(this, ['listenUserSelect', 'handleSwitchOn', 'getSupportedKeys',
            'keyBoardEvent', 'wrapperIsActiveState', 'getContainer', 'bindSwitchRef', 'removeBlockListen']);
        const arrowController = this.arrowController = [
            {handleKey: 'top arrow', title: '向上移动', id: 0, svgCom: ArrowTopSvgCom},
            {handleKey: 'right arrow', id: 1, svgCom: ArrowRightSvgCom},
            {handleKey: 'left arrow', id: 2, svgCom: ArrowLeftSvgCom},
            {handleKey: 'down arrow', id: 3, svgCom: ArrowDownSvgCom}
        ];
        const keyController = this.keyController = [
            {handleKey: 'w', id: 4, svgCom: WSvgCom},
            {handleKey: 'd', id: 5, svgCom: DSvgCom},
            {handleKey: 'a', id: 6, svgCom: ASvgCom},
            {handleKey: 's', id: 7, svgCom: SSvgCom},
            {handleKey: 'space',
                id: 8,
                width: 60,
                height: 60,
                viewBox: '0 0 187 187',
                svgCom: SpaceSvgCom
            }
        ];
        this.virtualKeyData = [
            {className: style.dirVirtualController, id: 0, children: arrowController},
            {className: style.wordVirtualController, id: 1, children: keyController}
        ];
        const children = arrowController.concat(keyController);
        this.addProcessedTouchEvent(children,
            {handleTouchStart: this.keyBoardEvent, handleTouchEnd: this.keyBoxTouchEnd});
        this.wrapperEventMiddleWare(children, 'handleTouchStart', ['handleKey', 'id'], this);
        this.wrapperEventMiddleWare(children, 'handleTouchEnd', ['handleKey', 'id'], this);
    }

    componentDidMount (){
        this.props.vm.on('LISTEN_BLOCK_EVENT', this.listenUserSelect);
        // 在 DidMount 一次之后初始化switch开关位置
        setTimeout(() => {
            this.initWrapperEle(this.switchRef, ...this.calcSwitchElePos());
        });
    }

    componentWillUnmount (){
        this.removeBlockListen();
        if (!this.wrapEle) {
            return;
        }
        this.wrapEle.parentNode.removeChild(this.wrapEle);
    }

    removeBlockListen (){
        this.props.vm.removeListener('LISTEN_BLOCK_EVENT', this.listenUserSelect);
    }

    calcSwitchElePos (){
        const x = -30;
        let y = 70;
        const headerEle = document.getElementsByClassName(`.${GblobalmenuBarClassHash}`);
        if (!(headerEle && headerEle[0])) return [x, y];
        const headerHeight = getComputedStyle(headerEle[0]).height.slice(0, -2);
        y = headerHeight + 20;
        return [x, y];
    }

    /*
     * @param x {Number} 需要挂载的x值
     * @param y {Number} 需要挂载的y值
     * @return {HTMLElement}
     */
    initWrapperEle (ele, x, y){
        ele.classList.add(switchClassName);
        if (x < 0) {
            ele.style.right = `${Math.abs(x)}px`;
        } else {
            ele.style.left = `${x}px`;
        }
        if (y < 0) {
            ele.style.bottom = `${Math.abs(y)}px`;
        } else {
            ele.style.top = `${y}px`;
        }
        ele.setAttribute('role', 'switch');
        return ele;
    }

    /*
     * @desc 接收mao对象，为list的item增加固定的value，避免冗余代码
     * @param list
     * @param map
     */
    addProcessedTouchEvent (list, map) {
        for (let i = 0; i < list.length; i++) {
            const listChild = list[i];
            Object.keys(map).forEach(key => {
                listChild[key] = map[key];
            });
        }
    }

    /*
     * @param event{Object} react TouchEnd 事件对象
     * @param id virtualBox 的 id 值
     * @return undefined
     */
    keyBoxTouchEnd (event, key, id) {
        const currentActiveKeyIds = this.state.currentActiveKeyIds;
        const matchIndex = currentActiveKeyIds.findIndex(CurrentId => CurrentId === id);
        if (matchIndex < 0) {
            return;
        }
        const [eventKey, eventKeyCode] = this.transformDownedKeys(key);
        simulateKeyBoard(document.body, 'keyup', eventKey, eventKeyCode);
        currentActiveKeyIds.splice(matchIndex, 1);
        this.setState({currentActiveKeyIds});
    }

    /*
     * @desc 值转换，由于主动触发浏览器的键盘事件，这个key名称不能和数据结构中的handleKey相对应，所以需要转换一下。
     * @param key
     * @return {*[]}
     */
    transformDownedKeys (key){
        const browserKeyMap = {
            'top arrow': 'ArrowUp',
            'right arrow': 'ArrowRight',
            'down arrow': 'ArrowDown',
            'left arrow': 'ArrowLeft',
            'space': ' '
        };
        const browserKeyCodeMap = {
            'ArrowLeft': 37,
            'ArrowUp': 38,
            'ArrowRight': 39,
            'ArrowBottom': 40,
            ' ': 32
        };
        const exceptForArrow = (innerKey, type) => {
            const arrKey = Object.keys(browserKeyMap);
            const isInclude = arrKey.indexOf(innerKey) > -1;
            if (type === 'key') {
                return isInclude ? browserKeyMap[innerKey] : innerKey;
            }
            return isInclude ? browserKeyCodeMap[browserKeyMap[innerKey]] : innerKey.charCodeAt(0);
        };
        const eventKey = exceptForArrow(key, 'key');
        const eventKeyCode = exceptForArrow(key, 'code');
        return [eventKey, eventKeyCode];
    }

    /*
     * @desc 触发虚拟键盘事件
     * @param key
     * @return undefined Processing function
     */
    keyBoardEvent (event, key, id) {
        const [eventKey, eventKeyCode] = this.transformDownedKeys(key);
        this.state.currentActiveKeyIds.push(id);
        this.setState({currentActiveKeyIds: this.state.currentActiveKeyIds});
        simulateKeyBoard(document.body, 'keydown', eventKey, eventKeyCode);
    }

    /*
     * @desc Transforming the value of item to a primitive function as a parameter;
     * 后期会支持双层结构.
     * @param list
     * @param methodName
     * @param neededAddToArguKey
     * @return undefined, Functional function and no returns
     */
    wrapperEventMiddleWare (list, methodName, neededAddToArguKey, context) {
        for (let i = 0; i < list.length; i++) {
            const item = list[i];
            const func = item[methodName];
            if (!item[methodName]) {
                return;
            }
            item[methodName] = e => {
                if (Array.isArray(neededAddToArguKey)) {
                    const values = neededAddToArguKey.map(key => item[key]);
                    func.apply(context, [e, ...values]);
                } else {
                    func.apply(context, [e, item[neededAddToArguKey]]);
                }
            };
        }
    }

    /*
     * @desc 包裹 isActive 属性为 item
     * @param list {Arrat [Object]}
     * @return undefined
     */
    wrapperIsActiveState (list) {
        for (let i = 0; i < list.length; i++) {
            const keyBoxItem = list[i];
            keyBoxItem.isActive = this.state.currentActiveKeyIds.indexOf(keyBoxItem.id) !== -1;
        }
    }

    /*
     * @note 直接监听vm中listenBlocks事件，它是通过vm实例中的 events 事件线来fire的。
     * @param listenBlocks 的事件对象
     */
    listenUserSelect (event) {
        const keyValue = event.newValue;
        const eventType = event.type;
        const eventName = event.name;
        const blockId = event.blockId;

        if (!this.state.isFirstDragin) {
            this.removeBlockListen();
            return;
        }

        if (!this.supportedKeys.length) {
            this.supportedKeys = this.getSupportedKeys();
        }

        // 两种情况显示
        // 1. event.type === ui && event.oldValue === event_whenkeypressed && 下一次 end Drag 了。也就是说，首次拖入, 并且支持这个key
        if (eventType === 'endDrag') {
            event.getEventWorkspace_().topBlocks_.forEach(currentBlock => {
                if (currentBlock.id === blockId && currentBlock.inputList) {
                    /* 确定到这里是已经拖入操作区，因为endDrag类型的事件不一定是拖入到了画布的目标区域，
                     也有可能拖到其他无用的地方，必须与当前画布上的topBlocks的值重新验证(topBlocks数组是当前已经存在于画布上的顶级block)，
                     然后查看当前的是否已经拖入了目标区域。

                     blockType 为 sensing_keypressed 时和 event_whenkeypressed 数据格式不一样
                     sensing_keypressed 对应的是侦测里面的 "按下...键?",
                     event_whenkeypressed 对应的是事件上的 '当按下...键'
                    */
                    const blockType = currentBlock.type;
                    if (currentBlock.type === 'sensing_keypressed') {
                        const list = currentBlock.childBlocks_[0].inputList;
                        if (!(list && list[0])) return;
                    }

                    let dropDownFiled;

                    if (blockType === 'event_whenkeypressed') {
                        dropDownFiled = currentBlock.inputList[0].fieldRow[1];
                    }

                    if (blockType === 'sensing_keypressed') {
                        dropDownFiled = currentBlock.childBlocks_[0].inputList[0].fieldRow[0];
                    }

                    if (!dropDownFiled) return;

                    if (this.supportedKeys.indexOf(dropDownFiled.value_) > -1) {
                        this.setState({
                            isFirstDragin: false,
                            controllerVisible: true
                        });
                    }
                }
            });
        }

        // 2. eventName === 'KEY_OPTION' && eventType === 'change' && 支持此key。 也就是说，拖入之后，再切换
        if (eventName === 'KEY_OPTION' && eventType === 'change' && this.supportedKeys.indexOf(keyValue) > -1) {
            this.setState({
                isFirstDragin: false,
                controllerVisible: true
            });
        }
    }

    handleSwitchOn () {
        this.setState({
            // 这里简便写法，因为只要触发switch操作，就说明 virtualBoardContoller 之前一定显示过，所以直接把 isFIrstDragin 置为false就可以。
            isFirstDragin: false,
            controllerVisible: !this.state.controllerVisible
        });
    }

    /*
     * @desc 获取一次
     * @param keyValue
     * @return {boolean}
     */
    getSupportedKeys (){
        const defaultSupportedKeys = ['any'];
        // 收集 handleKey
        for (let i = 0; i < this.virtualKeyData.length; i++) {
            const virtualKeyChildren = this.virtualKeyData[i].children;
            for (let j = 0; j < virtualKeyChildren.length; j++) {
                const virtualKeyItem = virtualKeyChildren[j];
                defaultSupportedKeys.push(virtualKeyItem.handleKey);
            }
        }
        return defaultSupportedKeys;
    }

    getContainer (){
        const container = document.createElement('div');
        document.body.appendChild(container);
        return container;
    }

    bindSwitchRef (ref){
        this.switchRef = ref;
    }

    render () {
        const {controllerVisible, isFirstDragin} = this.state;
        const nProps = omit(this.props, ['visible']);
        this.wrapperIsActiveState(this.keyController.concat(this.arrowController));

        return (<Portal
            getContainer={this.getContainer}
        >
            <div ref={this.bindSwitchRef}>
                <SwitchSvg
                    className={classnames(style.virtualSwitchSvg, {active: controllerVisible})}
                    height="68"
                    role="switch"
                    viewBox="0 0 136 136"
                    width="68"
                    /* eslint-disable */
                    onTouchStart={this.handleSwitchOn}
                    /* eslint-enable */
                />
            </div>
            <VirtualKeyBoard
                isFirstDragin={isFirstDragin}
                virtualKeyData={this.virtualKeyData}
                visible={controllerVisible}
                {...nProps}
            />
        </Portal>);
    }
}

KeyBoardLogic.propTypes = {
    vm: PropTypes.instanceOf(VM)
};

export default KeyBoardLogic;
